/**
 * Trata erros de retorno das requisições
 * @param {Object} error - Erro retornado da requisição
 * @return {String} - Retorna uma mensagem de erro
 */
const handleError = error => {
  if (error.response) {
    const status = error.response.status;

    /** Não autoriazado */
    if (status == 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("auth_username");
      localStorage.removeItem("auth_userid");
      window.location.href = "/login/";
    }

    /** Bad request */
    if (status == 400) return error.response.data.message;

    /** Internal server error */
    if (status == 500) return "Ocorreu um erro interno.";

    /** Not found */
    if (status == 404)
      if (error.response.data && error.response.data.message)
        return error.response.data.message;
  } else return "Sem resposta do servidor.";
};

export default handleError;



// WEBPACK FOOTER //
// ./src/services/apiErrorHandler.js